"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDefaultProps = exports.propose = void 0;
const react_1 = require("react");
/**
 * Takes a supplied component or intrinsic HTML element key, and return a new component with the supplied default props set.
 *
 * @param Component Either a React component, or any intrinsic element key (div, h1)
 * @param props The props to fill-in
 * @param displayName Optionally pass this for use in React
 * @returns A new component, props pre-filled with those supplied in the second argument
 */
function propose(Component, props, displayName) {
    if (typeof Component === 'string') {
        const NewComponent = (0, react_1.forwardRef)((p, ref) => {
            const combinedProps = Object.assign(Object.assign(Object.assign({}, props), p), { ref });
            return (0, react_1.createElement)(Component, combinedProps);
        });
        NewComponent.displayName = displayName;
        return NewComponent;
    }
    const NewComponent = (p) => {
        const combinedProps = Object.assign(Object.assign({}, props), p);
        return (0, react_1.createElement)(Component, combinedProps);
    };
    NewComponent.displayName = displayName;
    return NewComponent;
}
exports.propose = propose;
/**
 * Takes a supplied component or intrinsic HTML element key, and return a new component with the supplied default props set.
 *
 * @param Component Either a React component, or any intrinsic element key (div, h1)
 * @param props The props to fill-in
 * @param displayName Optionally pass this for use in React
 * @returns A new component, props pre-filled with those supplied in the second argument
 */
exports.withDefaultProps = propose;
